import { Trans } from '../../atoms'
import DatatableRowOrdine from '../../molecules/DatatableRowOrdine/DatatableRowOrdine'
import DatatableRowPersonalizzazioneOrdine from '../../molecules/DatatableRowPersonalizzazioneOrdine/DatatableRowPersonalizzazioneOrdine'
import Datatable from '../../atoms/Datatable/Datatable'
import { DatatableCartCols } from '../../molecules/DatatableRowCart/DatatableRowCart'
import { getRigheOrdineFromPersonalizzazione } from '../../../utils/postOrdine'
import styles from './PersonalizzazioneOrdine.module.sass'

const DatatableCols = { ...DatatableCartCols }
delete DatatableCols['personalizzazione']
delete DatatableCols['actions']

const PersonalizzazioneOrdine = ({ personalizzazione, indice, mostraNote }) => {
  const righe_per_personalizzazione = getRigheOrdineFromPersonalizzazione(personalizzazione)

  return (
    <div className="pdf__subsection">
      {personalizzazione.personalizzazione_posizione_1 ||
      personalizzazione.personalizzazione_posizione_2 ? (
        <h4>
          <Trans chiave="Personalizzazione" /> {personalizzazione.nome_lavorazione}
        </h4>
      ) : (
        <h4>
          <Trans chiave="Articoli non personalizzati" />
        </h4>
      )}
      <Datatable cols={DatatableCols}>
        {righe_per_personalizzazione.map((riga, i) => {
          return (
            <DatatableRowOrdine
              articolo={riga.articolo}
              quantita={riga.quantita}
              prezzo={riga.prezzo_unitario_netto}
              totale={riga.prezzo_totale_netto}
              even={i % 2 == 0}
              key={i}
            />
          )
        })}
        {(personalizzazione.personalizzazione_posizione_1 ||
          personalizzazione.personalizzazione_posizione_2) && (
          <DatatableRowPersonalizzazioneOrdine
            personalizzazione_posizione_1={personalizzazione.personalizzazione_posizione_1}
            personalizzazione_posizione_2={personalizzazione.personalizzazione_posizione_2}
            totale_personalizzazione={personalizzazione.prezzo_personalizzazione}
            stesso_logo={personalizzazione.stesso_logo}
            confezionamento_richiesto_personalizzazione={
              personalizzazione.confezionamento_richiesto_personalizzazione
            }
            confezionamento_richiesto={personalizzazione.confezionamento_richiesto}
            confezionamento={personalizzazione.confezionamento?.nome}
            articolo={personalizzazione.articolo}
          />
        )}
      </Datatable>
      <div className={styles['personalizzazione--notes']}>
        {mostraNote && righe_per_personalizzazione.some((riga) => riga.nota) && (
          <>
            <p>
              <strong>
                <Trans chiave="Note di lavorazione:" />
              </strong>{' '}
            </p>
            {righe_per_personalizzazione.map(
              (riga) =>
                riga.nota && (
                  <p>
                    {riga.articolo.codice} - <Trans chiave="note: " /> {riga.nota}
                  </p>
                )
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default PersonalizzazioneOrdine
